import { render } from "./CreateInvoice.vue?vue&type=template&id=2939f618&scoped=true&ts=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=ts"
export * from "./CreateInvoice.vue?vue&type=script&lang=ts"

import "./CreateInvoice.vue?vue&type=style&index=0&id=2939f618&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2939f618"]])

export default __exports__